// 商机详情重构
export default {
  // 基础详情
  globalLoading: false,
  basicBizoppInfo: {
  },
  configKeys: {}
}
